<template>
  <div class="viewstategyNew">
    <div class="stategyHeader">
      <div @click="toStrategy()">
        <i class="iconfont icon-fanhui1"></i>
        <span class="toStyle">{{$t('strategy.to')}}</span>
      </div>
      <span>{{$t('strategy.add_strategy')}}</span>
    </div>
    <div class="stategyIntro" v-if="false">
      <p class="stategyIntroTitle">{{ $t('strategy.strategyInfor') }}</p>
      <div class="stategyStep">
        <div class="stategyStepDiv">
          <div class="stategyStepOne">
            <p>
              <span>{{$t('strategy.stategyDetail') }}：</span>
              <span>{{detailData.strategyName}}</span>
            </p>
            <p>
              <span>{{$t('strategy.stategyDetail1') }}：</span>
              <span>{{detailData.firmwareName}}</span>
            </p>
          </div>
          <div class="stategyTriangle"></div>
        </div>
        <div class="stategyStepDiv">
          <div class="stategyStepOne">
            <p>
              <span>{{$t('strategy.stategyDetail2') }}：</span>
              <span>{{detailData.firmwareSize}}</span>
            </p>
            <p>
              <span>{{$t('strategy.stategyDetail3') }}：</span>
              <span>{{detailData.firmwareType}}</span>
            </p>
          </div>
          <div class="stategyTriangle"></div>
        </div>
        <div class="stategyStepDiv">
          <div class="stategyStepOne">
            <p>
              <span>{{$t('strategy.stategyDetail4') }}：</span>
              <span>{{detailData.baudrate}}</span>
            </p>
            <p>
              <span>{{$t('strategy.stategyDetail5') }}：</span>
              <span v-if="this.detailData.strategyType==0">{{$t('strategy.uprade_name')}}</span>
              <span v-if="this.detailData.strategyType==1">{{$t('strategy.uprade_name1')}}</span>
            </p>
          </div>
          <div class="stategyTriangle"></div>
        </div>
        <div class="stategyStepDiv">
          <div class="stategyStepOne">
            <p>
              <span>{{$t('strategy.stategyDetail6') }}：</span>
              <span>{{detailData.alreadyUpgradeDeviceCount}}/{{ detailData.upgradeDeviceCount }}</span>
            </p>
            <p>
              <span>{{$t('strategy.stategyDetail7') }}：</span>
              <span v-if="this.detailData.strategyStatus==0">{{$t('strategy.Not_started')}}</span>
              <span v-if="this.detailData.strategyStatus==1">{{$t('strategy.expired')}}</span>
              <span v-if="this.detailData.strategyStatus==2">{{$t('strategy.In_effect')}}</span>
            </p>
          </div>
          <div class="stategyTriangle"></div>
        </div>
        <div class="stategyStepDiv">
          <div class="stategyStepOne">
            <p>
              <span>{{$t('strategy.stategyDetail8') }}：</span>
              <span>{{detailData.startTime}}</span>
            </p>
            <p>
              <span>{{$t('strategy.stategyDetail9') }}：</span>
              <span>{{detailData.endTime}}</span>
            </p>
          </div>
          <div class="stategyTriangle"></div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="search">
        <div class="searchLeft">
          <span class="search-label">{{ $t('strategy.uprade_status') }}</span>
          <el-select
            v-model="search.status"
            clearable
            @change="getupgradeDetailList(true)"
            :placeholder="$t('header.pleaseSelect')"
            popper-class="select-search-recharge"
            class="selectClearNew"
          >
            <el-option
              v-for="(value) in upgradeStatus"
              :key="value.value"
              :value="value.value"
              :label="value.label"
              style="display:flex;align-items:center;"
            >
              <span class="select-label">{{ value.label }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="searchRight">
          <!-- 搜索 -->
          <div class="search-alert" v-if="showSearch">
            <!-- :placeholder="$t('recharge.pn')" -->
            <!-- v-model="inputText" -->
            <!-- @input实时查询 -->
            <!-- @keyup.enter.native -->
            <div class="searchDiv">
              <el-input
                class="searchAll"
                ref="iptFocus"
                v-model.trim="search.search"
                @keyup.enter.native="getupgradeDetailList()"
                :placeholder="this.$t('device.datalogger_pn')"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <!-- 搜索 -->
              <span
                class="search-device"
                @click="getupgradeDetailList()"
              >{{ $t('recharge.Search') }}</span>
              <!-- 取消 -->
              <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
            </div>
          </div>
          <el-button class="button button-solid" @click.stop="showSearchBtn">
            <i class="el-icon-search"></i>
          </el-button>
        </div>
      </div>
      <el-table
        :data="upgradeDetailList"
        stripe
        border
        height="100%"
        v-loading="isLoading"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        element-loading-spinner="el-icon-loading"
        class="tablemain tableloding"
        :empty-text="$t('account.nodata')"
        ref="multiplePnTable"
      >
        <el-table-column :label="this.$t('settingalarm.list')" fixed type="index" width="70"></el-table-column>
        <el-table-column
          min-width="140px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.Datalogger_Name')"
        >
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            <span :title="scope.row.collectorAlias || scope.row.pn">
              {{
              scope.row.collectorAlias || scope.row.pn }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="pn"
          min-width="140px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.Datalogger_PN')"
        ></el-table-column>
        <el-table-column
          prop="upgradeStatus"
          width="200px;"
          :show-overflow-tooltip="true"
          :label="this.$t('strategy.uprade_status')"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.upgradeStatus==0"
              style="background-color: rgba(183,183,183,0.16);color:#B7B7B7;border-radius: 5px;padding: 2px 8px;display: inline-block;"
            >{{$t('strategy.Not_upgraded')}}</span>
            <span
              v-else-if="scope.row.upgradeStatus==1"
              style="background-color: rgba(51,255,182,0.16);color:#33FFB6; border-radius: 5px;padding: 2px 8px;display: inline-block;"
            >{{$t('strategy.Yes_started')}}</span>
            <span v-else>{{"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="executionTime"
          width="200px;"
          :show-overflow-tooltip="true"
          :label="this.$t('device.device_upgradeTime')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.executionTime || '--'">{{ scope.row.executionTime || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="upgradeResult"
          width="200px;"
          :show-overflow-tooltip="true"
          :label="this.$t('strategy.uprade_result')"
        >
          <template slot-scope="scope">
            <span
              style="color:#33FFB6 ;"
              v-if="scope.row.upgradeResult==='0'"
            >{{ $t('strategy.uprade_success')}}</span>
            <span
              style="color: #EC3030;"
              v-else-if="scope.row.upgradeResult==1"
            >{{ $t('strategy.uprade_fail')}}</span>
            <span v-else>{{"--"}}</span>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <div v-show="emptyText" slot="empty">
          <div style="line-height: 32px">{{$t('account.nodata')}}</div>
        </div>
      </el-table>
    </div>
  </div>
</template>
  <script>
export default {
  props: {
    strategynewListParam: {
      type: Object
    }
  },
  data() {
    return {
      // 升级状态
      upgradeStatus: [
        {
          label: this.$t("strategy.Not_upgraded"),
          value: 0
        },
        {
          label: this.$t("strategy.Yes_started"),
          value: 1
        }
      ],
      emptyText: false,
      search: {
        status: "",
        search: "",
        time: ""
      },
      loadingUpgrade: false,
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      // 策略列表数据
      upgradeDetailList: [],
      // 搜索弹出
      showSearch: false,
      //详情Id
      detailId: this.strategynewListParam.id,
      // 策略详情信息
      detailData: {},
      isLoading: false
    };
  },
  created() {
    // this.getDetail();
    this.getupgradeDetailList();
  },
  methods: {
    // 获取策略列表数据
    getupgradeDetailList() {
      this.isLoading = true;
      let params = {
        strategyId: this.detailId,
        pn: this.search.search,
        operate:'select',
        upgradeStatus: this.search.status
      };
      this.$request
        .get("deviceFirmwareUpgradeStrategy", params)
        .then(res => {
          if (res.err == 0) {
            this.upgradeDetailList = res.dat;
          } else {
            this.emptyText = true;
            this.dataCode = [];
            this.pagination.total = 0;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.emptyText = true;
          this.dataCode = [];
          this.pagination.total = 0;
          this.isLoading = false;
        });
    },
    // 获取策略详情
    getDetail() {
      let params = {
        id: this.detailId
      };
      let action = "/upg/api/auth/web/strategy/detail/" + this.detailId;
      this.$request.getUPG(action, params).then(res => {
        if (res.code == 0) {
          this.detailData = res.data;
          if (this.detailData.firmwareSize) {
            this.detailData.firmwareSize = Math.ceil(
              this.detailData.firmwareSize / 1024
            );
          } else {
            this.detailData.firmwareSize = "0";
          }
        }
      });
    },
    // 返回升级策略列表
    toStrategy() {
      this.$emit("noticeStrategyNewBox", 1);
      // this.$router.push({
      //   path: "strategy",
      // });
    },
    // 关于搜索弹窗 =====
    // 关闭搜索框
    closeSearch() {
      this.showSearch = false;
      this.search.pn = "";
      this.search.status = "";
      this.search.type = "";
      this.search.time = "";
      this.search.search = "";
      this.getupgradeDetailList();
    },
    showSearchBtn() {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    }
  }
};
</script>
  <style lang="less" scoped>
@import url("../../assets/css/mixin.less");
.viewstategyNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;
  .stategyHeader {
    display: flex;
    padding: 0 0 15px 0;
    font-size: 20px;
    color: #ffffff;
    align-items: center;
    background-color: #2d3f4b;
    i {
      font-size: 26px;
    }
    div:hover {
      cursor: pointer;
    }
    .toStyle {
      margin: 0 20px 0 5px;
    }
  }
  .stategyIntro {
    color: #f3fafe;
    background-color: #222d35;
    padding: 0 20px;
    font-weight: 700;
    margin-bottom: 20px;
    overflow: auto;
    .stategyIntroTitle {
      font-size: 20px;
      line-height: 26px;
      padding: 13px 0;
    }
    .stategyIntroDisc {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .strategyIntro {
        background-color: @primaryTextColor;
        width: 13px;
        height: 13px;
        border-radius: 13px;
        margin-right: 20px;
      }
    }
    .stategyStep {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 15px;
      height: 134px;
      .stategyStepDiv {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        width: 270px;
        .stategyStepOne {
          z-index: 4;
          padding-left: 15px;
          border-radius: 8px 0 0 8px;
          width: 235px;
          background-color: #2b3842;
          p:first-child {
            font-size: 14px;
            font-weight: 700;
            padding: 30px 0 5px;
            height: 60px;
          }
          p:last-child {
            overflow: hidden;
            height: 60px;
            font-size: 14px;
            font-weight: 700;
            padding: 5px 0 30px;
          }
        }
        .stategyTriangle {
          z-index: 3;
          position: absolute;
          left: 195px;
          width: 76px;
          height: 76px;
          transform: rotate(-60deg) skewX(-30deg) scale(1, 0.8);
          border-bottom-right-radius: 10%;
          border-top-right-radius: 10%;
          border-bottom-left-radius: 10%;
          background-color: #2b3842;
        }
      }
    }
  }
  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      // align-self: flex-end;
      align-items: center;
      display: flex;
      justify-content: space-between;
      position: relative;
      .searchRight {
        display: flex;
        justify-content: flex-end;
        .buttonDeviceJurisdiction {
          padding: 0 17px 0 12px;
          background-color: @primaryTextColor;
          color: #222d35;
          border-radius: 0;
          span {
            padding-left: 5px;
          }
        }
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 110px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {
          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px !important;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #33ffb6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7b8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202d35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: "X";
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      // /deep/.el-table--border::after,
      // /deep/.el-table--group::after {
      //   width: 0px;
      // }
      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox
        .el-checkbox__input.is-indeterminate
        .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }
}
</style>
  <style lang="less">
// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

.selectClearNew {
  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

// #时间选择器 el-date-picker#
.select-date {
  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00febb;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00febb;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }

  // 月
  .el-month-table td.today .cell {
    color: #00febb;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7b8395;
  }

  .el-month-table td .cell:hover {
    color: #00febb;
  }

  // 切换年 -----
  // 年
  .el-year-table td.today .cell {
    color: #00febb;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7b8395;
  }

  .el-year-table td .cell:hover {
    color: #00febb;
  }
}
.tablemain.el-table--border::after {
  display: none;
}

.dataloggerManage {
  .scqsbAlert {
    .el-table--border::after,
    .el-table--group::after {
      display: block;
      background-color: #a3a9b5;
    }

    // 弹窗表格右侧边线
    .el-table--border {
      border-right: 1px solid #a3a9b5;
    }

    // 滚动条
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }

    // 加载数据
    .el-loading-mask {
      background-color: transparent;
    }

    .el-loading-spinner i {
      color: @primaryTextColor;
    }
  }
}
</style>